import { getLang } from "helpers/themeHelpers";


export const linkToTermOfUse = () => {
  const locale = getLang();
  return `/${locale}/termOfUse`;
};
